import * as React from "react"
import {map as _map} from "lodash";
import { IMedicinePrescription } from "@curefit/ehr-common";

/**
 * Created by aditya on 28/01/18.
 */

export interface MedicationTagsContainerProps {
    medicine?: IMedicinePrescription;
    tags: string[];
    value?: string;
    onCancelHandler?: (value: number) => void;
    hideCancelButton?: boolean;
}

class MedicationTagsContainer extends React.Component<MedicationTagsContainerProps> {
    render() {
        let self = this;
        let tags = this.props.tags;
        return (
            <div className={"tags-container"}>
                {
                    _map(tags, (tag, index) => {
                        return <div className={"tag"} key={`tag-${tag}-${index}`}>
                                <span className={"label"}>{tag}</span>
                                {
                                    self.props.hideCancelButton !== undefined && !self.props.hideCancelButton &&
                                    <a className={"cancel-button"} onClick={() => this.props.onCancelHandler(index)}>x</a>
                                }
                            </div>
                    })
                }
            </div>
        )
    }
}

export default MedicationTagsContainer;